import dashboardServices from '../services/hoa-dashboard-api-service';
import datastore from '../store/hoa-datastore';

export default function LoadingController(){

    const checkAccessRights = async () => {
        try {
            const response = await dashboardServices.checkAccessRights();
            return { unauthorized: response.data === 'unauthorized', forbidden:response.data === 'forbidden'} 
        } catch (error) {
            return { unauthorized:true, forbidden:true}
        }
    }

    const checkUserRole = async () => {
        const response = await dashboardServices.checkUserRole();
        return {role:response.data};
    }

    const getUserDataInformation = async () => {

        const response = await dashboardServices.getUserInformation();
        if(response.data) {
            datastore.ownerInformation.id = response.data.objectId;
            if(response.data.firstName && response.data.lastName) {
                datastore.ownerInformation.name = response.data.firstName+" "+response.data.lastName;
            } else {
                datastore.ownerInformation.name = response.data.email;
            }
            datastore.ownerInformation.email = response.data.email;
            datastore.ownerInformation.img = response.data?._parseObject?.thumbUrl;
        }

    }

    const checkWhichOrgUser = async (userId: string) => {
        const response = await dashboardServices.checkWhichOrgUser(userId);
        return {organizations:response.data};
    }

    return {
        checkAccessRights,
        getUserDataInformation,
        checkUserRole,
        checkWhichOrgUser
    }
}